import React from "react";
import { useMutation, useQuery } from "react-query";
import Axios from "axios";
import { Form, Input, Button } from "antd";
import {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
} from "../../../../../helpers/AsyncMessage";
import ModalSpecial from "../../../../../components/Layout/Modals/ModalSpecial";
import SkuPopover from "../Components/SkuPopover";

const fetchProducts = async () => {
  const response = await Axios.get("api/v1/products");
  return response.data;
};

const ModalBulkProduct = ({ onClose, modalOpt, selectedSkus }) => {
  const [form] = Form.useForm();
  const [open, setOpen] = React.useState(false);
  const [searchVal, setSearchVal] = React.useState("");
  const [selectedSkusValue, setSelectedSkusValue] = React.useState([]);

  const {
    data: products,
    isLoading,
    error,
  } = useQuery("products", fetchProducts);

  const mutationPOSTBulkUpdateQuantity = useMutation({
    mutationFn: (values) =>
      Axios.post("api/v1/product_suppliers/bulk_update", {
        product_supplier_ids: values.product_supplier_ids,
        quantity: values.quantity,
      }).then((res) => res.data),
    onSuccess: () => {
      antdAsyncMessageSuccess({
        text: "Successfully updated",
        key: "default",
      });
      onClose();
    },
    onError: () => {
      antdAsyncMessageError();
    },
  });

  const mutationPOSTBulkUpdateWholesalePrice = useMutation({
    mutationFn: (values) =>
      Axios.post("api/v1/product_suppliers/bulk_update", {
        product_supplier_ids: values.product_supplier_ids,
        wholesale_price: values.wholesale_price,
      }).then((res) => res.data),
    onSuccess: () => {
      antdAsyncMessageSuccess({
        text: "Successfully updated",
        key: "default",
      });
      onClose();
    },
    onError: () => {
      antdAsyncMessageError();
    },
  });

  const removeSku = (id) => {
    const newSelectedSkus = [...selectedSkusValue];
    const index = newSelectedSkus.findIndex((sku) => sku.id === id);
    if (index !== -1) {
      newSelectedSkus.splice(index, 1);
    }
    if (newSelectedSkus?.length === 0) {
      onClose();
    }
    setSelectedSkusValue(newSelectedSkus);
  };

  React.useEffect(() => {
    setSelectedSkusValue(selectedSkus);
  }, [selectedSkus]);

  return (
    <ModalSpecial
      style={{
        width: 300,
      }}
      text={
        <span className="d-flex align-items-center justify-content-between w-100">
          <div>
            <span className="font-bold text-xl text-black">
              Change{" "}
              {modalOpt.type === "bulk_quantity_product"
                ? "quantity"
                : "whole price"}
            </span>
          </div>
        </span>
      }
      onClose={onClose}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={(values) => {
          const product_supplier_ids = selectedSkusValue.map((item) => item.id);
          if (modalOpt.type === "bulk_quantity_product") {
            mutationPOSTBulkUpdateQuantity.mutate({
              ...values,
              product_supplier_ids,
            });
          } else {
            mutationPOSTBulkUpdateWholesalePrice.mutate({
              ...values,
              product_supplier_ids,
            });
          }
        }}
        autoComplete="off"
      >
        <Form.Item label="SKU" name="product_id">
          <SkuPopover
            open={open}
            setOpen={setOpen}
            products={products}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
            selectedSkusValue={selectedSkusValue}
            removeSku={removeSku}
          />
        </Form.Item>
        {modalOpt.type === "bulk_quantity_product" ? (
          <Form.Item
            label="Quantity"
            name="quantity"
            rules={[
              {
                required: true,
                message: "Can't be empty",
              },
            ]}
          >
            <Input placeholder="Type in" />
          </Form.Item>
        ) : (
          <Form.Item
            label="Wholesale Price"
            name="wholesale_price"
            rules={[
              {
                required: true,
                message: "Can't be empty",
              },
            ]}
          >
            <Input
              placeholder="Type in"
              suffix={<p style={{ margin: 0 }}>€</p>}
            />
          </Form.Item>
        )}

        <Form.Item>
          <Button
            className="w-100"
            type="primary"
            htmlType="submit"
            loading={
              modalOpt.type === "bulk_quantity_product"
                ? mutationPOSTBulkUpdateQuantity.isLoading
                : mutationPOSTBulkUpdateWholesalePrice.isLoading
            }
          >
            Add
          </Button>
        </Form.Item>
      </Form>
    </ModalSpecial>
  );
};

export default ModalBulkProduct;
